import React, { useState } from "react";
import PharmacyDashboard from "./PharmacyDashboard/PharmacyDashboard";
import InventoryDashboard from "./Inventory/InventoryDashboard";
import POSDashboard from "./POS/POSDashboard";

const PharmacyWrapper = () => {
  // State to manage the active tab
  const [activeTab, setActiveTab] = useState("dashboard");

  // Render the active module
  const renderActiveModule = () => {
    switch (activeTab) {
      case "dashboard":
        return <PharmacyDashboard />;
      case "pos":
        return <POSDashboard />;
      default:
        return <PharmacyDashboard />;
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen p-8">
      {/* Navigation Menu */}
      <div className="bg-white shadow rounded p-4 mb-8 flex space-x-6">
        <button
          className={`text-lg font-semibold ${
            activeTab === "dashboard" ? "text-green-500" : "text-gray-700"
          }`}
          onClick={() => setActiveTab("dashboard")}
        >
          Pharmacy Dashboard
        </button>
      </div>

      {/* Render Active Module */}
      <div className="bg-white shadow rounded p-6">{renderActiveModule()}</div>
    </div>
  );
};

export default PharmacyWrapper;
